<template>
    <div class="w3-container">
      <div class="w3-margin-left">
        <p class="blue-text font-weight">{{$t("selectAccessType")}}</p>
        <div class="w3-margin">
          <div
               class="w3-padding-16"
               v-for="entry in accessControlEntries"
               :key="entry.id" @click="selectACType(entry)">
            <access-type-badge :accessType="entry.accessType || entry.id"></access-type-badge>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import {EventBus} from "@/main";
import Vue from "vue";
import AccessTypeBadge from "@/components/access-control/AccessTypeBadge";
const frc = Vue.prototype.$frc;

export default {
  name: "AccessControlPatient", components: {AccessTypeBadge}, props: ['accessControlEntries'],
  methods: {
    selectACType(entry) {
      EventBus.$emit("selectedACType", entry);
      this.hideCurrentScreen();
    },
    hideCurrentScreen() {
      EventBus.$emit("hideACTypeSelectionScreen");
    }
  }
}
</script>